// removed by extract-text-webpack-plugin
module.exports = {"base":"cms__index__base","container":"cms__index__container","rounded":"cms__index__rounded","depth":"cms__index__depth","clearfix":"cms__index__clearfix","editorControlBar":"cms__index__editorControlBar","editor":"cms__index__editor","dragging":"cms__index__dragging","shim":"cms__index__shim"};


//////////////////
// WEBPACK FOOTER
// ./components/Widgets/MarkdownControlElements/VisualEditor/index.css
// module id = 590
// module chunks = 0